@if ((open$ | async) !== true) {
  <button
    @fade
    mat-icon-button
    [color]="ghostButton ? 'ink' : 'secondary'"
    [class.zef-ghost-button]="ghostButton"
    (click)="onSearchOpen()"
  >
    <mat-icon>action_find</mat-icon>
  </button>
}

@if (open$ | async) {
  <div class="search-expand" @expand>
    <zef-input-search
      [placeholder]="placeholder"
      [value]="value"
      [autoFocus]="true"
      [space]="space"
      (valueChange)="onInput($event)"
      (close)="onSearchClose()"
    ></zef-input-search>
  </div>
}
